import { render, staticRenderFns } from "./SignIn.vue?vue&type=template&id=e70714d4&scoped=true&"
import script from "./SignIn.vue?vue&type=script&lang=js&"
export * from "./SignIn.vue?vue&type=script&lang=js&"
import style0 from "./SignIn.vue?vue&type=style&index=0&id=e70714d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70714d4",
  null
  
)

export default component.exports